import { render, staticRenderFns } from "./MarginDiv.vue?vue&type=template&id=fda38812&"
import script from "./MarginDiv.vue?vue&type=script&lang=js&"
export * from "./MarginDiv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports